import '../styles/RunMonitorMasthead.css';
import React from 'react';

function RunMonitorMasthead() {
  return (
    <section className="rmm-masthead" aria-labelledby="rmm-title">
      <div className="rmm-rail" data-content-rail="workspace">
        <div className="rmm-grid">
          <div className="rmm-lede">
            <span className="rmm-kicker">
              <span className="rmm-kicker__mark" aria-hidden="true" />
              Brute · operator console
              <span className="rmm-kicker__line" aria-hidden="true" />
            </span>
            <h1 id="rmm-title" className="rmm-heading">
              <span className="rmm-heading__word">Run</span>{' '}
              <span className="rmm-heading__word rmm-heading__word--monitor">Monitor</span>
            </h1>
            <p className="rmm-subline">
              Watch the live log, track stepped progress, stop or retry the task.
            </p>
            <a className="rmm-return" href="/dashboard">
              <span className="rmm-return__arrow" aria-hidden="true">←</span>
              Return to Dashboard
            </a>
          </div>

          <div className="rmm-side">
            <span className="rmm-sticker">
              <span className="rmm-sticker__inner">
                <span className="rmm-sticker__dot" aria-hidden="true" />
                Authorized target only
              </span>
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default RunMonitorMasthead;